document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
        item.addEventListener('click', function() {
            const answer = this.querySelector('.faq-answer');
            const icon = this.querySelector('.faq-icon');
            const question = this.querySelector('.faq-question');
            const isOpen = this.classList.contains('active');

            // Alle anderen FAQ-Items schließen
            faqItems.forEach(otherItem => {
                if (otherItem !== this) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.faq-answer').style.maxHeight = null;
                    otherItem.querySelector('.faq-icon').style.transform = 'rotate(0deg)';
                    const otherQuestion = otherItem.querySelector('.faq-question');
                    otherQuestion.classList.remove('font-medium', 'text-neutral-on-accent');
                }
            });

            // Aktuelles Item togglen
            if (isOpen) {
                this.classList.remove('active');
                answer.style.maxHeight = null;
                icon.style.transform = 'rotate(0deg)';
                question.classList.remove('font-medium', 'text-neutral-on-accent');
            } else {
                this.classList.add('active');
                answer.style.maxHeight = answer.scrollHeight + 'px';
                icon.style.transform = 'rotate(180deg)';
                question.classList.add('font-medium', 'text-neutral-on-accent');
            }
        });
    });
});
